import Button from 'components/Form/Button';
import { useHistory } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import {
  HeaderContainer,
  HeaderLeftMenu,
  HeaderMenuItem,
  RowCenter,
  RowEnd,
} from './styled';

export default function Header() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const options = {
    left: [{ title: 'Inicio', active: true, action: () => navigate('') }],
    right: [{ title: 'Login', button: true, action: () => navigate('login') }],
  };

  return (
    <HeaderContainer>
      <Container fluid>
        <Row style={{ justifyContent: 'space-between' }}>
          <Col md={{ size: 7 }}>
            <RowCenter>
              <HeaderLeftMenu>
                {options?.left?.map((item, key) =>
                  item.button ? (
                    <Button
                      key={key}
                      nospace
                      outline={item.outline}
                      onClick={item.action}
                    >
                      {item.title}
                    </Button>
                  ) : (
                    <HeaderMenuItem
                      key={key}
                      active={item.active}
                      onClick={item.action}
                    >
                      {item.title}
                    </HeaderMenuItem>
                  )
                )}
              </HeaderLeftMenu>
            </RowCenter>
          </Col>
          <Col md={{ size: 2 }}>
            <RowEnd>
              {options?.right?.map((item, key) =>
                item.button ? (
                  <Button
                    key={key}
                    nospace
                    outline={item.outline}
                    onClick={item.action}
                  >
                    {item.title}
                  </Button>
                ) : (
                  <HeaderMenuItem
                    key={key}
                    className={item.active ? 'active' : ''}
                    onClick={item.action}
                  >
                    {item.title}
                  </HeaderMenuItem>
                )
              )}
            </RowEnd>
          </Col>
        </Row>
      </Container>
    </HeaderContainer>
  );
}
